import { useEffect, useState } from 'react';
import axios from 'axios';
import { Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Teachers() {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(`${API}/teachers`);
      setTeachers(response.data);
    } catch (error) {
      console.error('Error fetching teachers:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section className="bg-gradient-to-br from-blue-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-brand-dark mb-6">Our Expert Teachers</h1>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto">
              Meet our dedicated faculty committed to your success
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-blue border-r-transparent"></div>
              <p className="mt-4 text-slate-600">Loading teachers...</p>
            </div>
          ) : teachers.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-slate-600 text-lg">No teachers available at the moment.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {teachers.map((teacher) => (
                <div
                  key={teacher.teacher_id}
                  data-testid={`teacher-card-${teacher.teacher_id}`}
                  className="feature-card hover:border-brand-blue transition-all"
                >
                  <div className="text-center mb-4">
                    <img
                      src={teacher.photo_url}
                      alt={teacher.name}
                      className="w-40 h-40 rounded-full mx-auto mb-4 object-cover border-4 border-brand-blue/10"
                    />
                    <h3 className="text-2xl font-semibold text-brand-dark mb-2 font-display">{teacher.name}</h3>
                    <p className="text-brand-blue font-medium text-lg mb-2">{teacher.subject}</p>
                    <p className="text-sm text-slate-500 mb-4">{teacher.experience}</p>
                  </div>
                  <p className="text-slate-600 leading-relaxed">{teacher.description}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-16 bg-brand-surface">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <Mail className="h-12 w-12 text-brand-blue mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-4">Want to Join Our Teaching Team?</h2>
          <p className="text-slate-600 mb-6">
            We're always looking for passionate educators. Contact us at{' '}
            <a href="mailto:careers@tutorflex.com" className="text-brand-blue hover:underline">
              careers@tutorflex.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
